import {createSelector} from 'reselect'

export const getLoading = createSelector(
  state => Boolean(state && state.scheduleTechnicalInspection && state.scheduleTechnicalInspection.isLoading),
  isLoading => isLoading
)
